module.exports = __webpack_public_path__ + "static/EGR_FlashPage_1-0aedf23d725f79294316e50366e2ca58.jpg";